export class RequestClose extends HTMLElement {
    private template: HTMLTemplateElement;

    constructor() {
        super();
        this.template = document.createElement('template');
        this.attachShadow({ mode: 'open' });
        this.template.innerHTML = '<spinner-element></spinner-element>';
    }

    connectedCallback() {
        this.shadowRoot.appendChild(this.template.content.cloneNode(true));

        // post message to notify host window when current login cycle runs in popup
        const bc = new BroadcastChannel('webagent-agent-assist-request-close');
        bc.postMessage('request-close');
    }
}

window.customElements.define('request-close-component', RequestClose);
